import { initializeApp } from 'firebase/app';

import {

  writeBatch,
  initializeFirestore } from
  'firebase/firestore';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase app first
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);

export function createGoogleAuthProvider({ forceReauth = false } = {}) {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    // login forces password re-entry even when the browser has an active Google session
    prompt: forceReauth ? 'login select_account' : 'select_account',
    hd: 'communityforwardsf.org'
  });
  return provider;
}

const googleProvider = createGoogleAuthProvider();
const storage = getStorage(app);

// Initialize Firestore with persistent cache (replaces deprecated enableIndexedDbPersistence)
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  cache: {
    size: 100 * 1024 * 1024, // 100MB cache size
    kind: 'persistent' // This enables IndexedDB persistence
  }
});

// Initialize Functions
const functions = getFunctions(app, 'us-central1');

// Connect to emulators in development
if (process.env.NODE_ENV === 'development') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectStorageEmulator(storage, 'localhost', 9199);
}

// Export everything
export { app, auth, db, functions, storage, googleProvider, writeBatch, firebaseConfig };
